import React from 'react';
import PropTypes from 'prop-types';
const LogoSvg = ({className, fillColor}) => {
  return (
    <svg className={className} viewBox="0 0 14.002 14.002">
      <path
        fill={fillColor}
        id="Chat"
        d="M4.376,7a.827.827,0,0,0,.875.875h3.5A.877.877,0,0,0,9.626,7a.827.827,0,0,0-.875-.875h-3.5A.877.877,0,0,0,4.376,7ZM0,4.376A4.333,4.333,0,0,1,4.376,0H9.626A4.333,4.333,0,0,1,14,4.376v8.751a.827.827,0,0,1-.875.875H4.376A4.333,4.333,0,0,1,0,9.626Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
LogoSvg.propTypes = {
  className: PropTypes.string,
  fillColor: PropTypes.string,
};

LogoSvg.defaultProps = {
  className: 'et-alw-img-right ',
  fillColor: '#2d2756',
};
export default LogoSvg;
